module.exports = __webpack_public_path__ + "static/media/YE.1a5bdd67.svg";